/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PropTypes from "prop-types";
import {
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Grid,
  FormGroup,
  IconButton,
} from "@material-ui/core"; // Remove the unused imports for CHG0073013
import WarningIcon from "@mui/icons-material/Warning";
import FormLabel from "@mui/material/FormLabel";
// import $ from 'jquery';
import clsx from "clsx";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { useHistory } from "react-router-dom";
import styles from "./OperativeDailyBooking.module.css";
import {
  CustomFormGroup,
  CustomNameTab,
  CustomSelect,
  CustomDatePicker,
  ValidatingTextField,
} from "../../components/FormComponents";
import BackButton from "../../components/BackButton/BackButton";
import {
  DATE_FORMAT,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  Regex,
} from "../../constants";
import { withAllowedOperationsProvider } from "../../hocs";
import { CustomTab, Button, AuthChecker } from "../../atomicComponents";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import TableSimple from "../../atomicComponents/TableSimple/TableSimple";
import { setLogin } from '../../redux/features/auth/actions';

const OperativeDailyBooking = () => {
  const history = useHistory();
  const dispatchNew = useDispatch();
  const { showPopup } = usePopupManager();
  // const baseUrl='http://127.0.0.1:8000/file/'
  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  const auth = useSelector((state) => state.auth); // useSelector
  const [dynamicColumns, setDynamicColumns] = useState([]);
  const [dynamicColumns1, setDynamicColumns1] = useState([]);
  const [plant, setPlant] = useState(null);
  const [flag, show] = useState(false);
  const [Bc, setBC] = useState(null);
  const [bcArray, setBcArray] = useState([]);
  const [plantArray, setPlantArray] = useState([]);
  const [tableArray, setTableArray] = useState([]);
  const [loader, setLoader] = useState(true);
  const [asnCount, setAsnCount] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);
  const [myState, setState] = useState({
    poNo: "",
    stmNo: "",
    chassisNo: null,
    toDate: null,
    fromDate: null,
    bodyBuilder: null,
    checkFlag: false,
    tableFlag: false,
    tableFlag1: false,
  });
  const [personnelNumber, setPersonnelNumber] = useState("");
  const [submitPressed, setSubmitPressed] = useState(false);
  const [bookingDate, setBookingDate] = useState(null);
  const [ProjectType, setProjectType] = useState("");
  const [bookingSubmit, setBookingSubmit] = useState(null);
  const [viewDatesToBook, setViewDatesToBook] = useState(false);
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState(null);
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [AddButtonClicked, setAddButtonClicked] = useState(false);
  const [projectOption, setProjectOption] = useState([
    { value: "Projects", label: "Projects" },
    { value: "Indirect Projects", label: "Indirect Projects" },
  ]);
  const [businessUnit, setBusinessUnit] = useState([
    { value: "Common", label: "Common" },
  ]);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [existingData, setExistingData] = useState([]);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const handleOpen = () => setIsPopupOpen(true);
  const [datesData, setDates] = useState({
    endDate: "",
    startDate: "",
  });

  const [checkedItems, setCheckedItems] = useState({});
  const handleCheckboxChange = (event, index) => {
    const { checked } = event.target;
    setCheckedItems((prevState) => ({
      ...prevState,
      [index]: checked,
    }));
  };

  const [selectedDate, setSelectedDate] = useState(null);
  const [sessionData, setSessionData] = useState([]);
  const [barrel, setBarrel] = useState([
    { value: "ED", label: "ED" },
    { value: "EB", label: "EB" },
    { value: "AE-T", label: "AE-T" },
    { value: "AE-V", label: "AE-V" },
  ]);

  const [projectDetails, setProjectDetails] = useState([
    { value: "ULTRA T.14 RDE", label: "ULTRA T.14 RDE" },
    { value: "W.22 EV 22", label: "W.22 EV 22" },
    {
      value: "W.22 EV 22 - Testing Project",
      label: "W.22 EV 22 - Testing Project",
    },
  ]);

  const [evmActivity, setEvmActivity] = useState([
    { value: "EFO Check Completed", label: "EFO Check Completed" },
    { value: "Tear Down & Benchmarking", label: "Tear Down & Benchmarking" },
    { value: "Advanced Engg", label: "Advanced Engg" },
  ]);

  const [module, setModule] = useState([
    { value: "Module Integration", label: "Module Integration" },
    { value: "Module 1", label: "Module 1" },
    { value: "Module 2", label: "Module 2" },
  ]);

  const [sessionTempData, setSessionTempData] = useState([
    {
      project_type: "",
      barrel: "",
      project_details: "",
      evm_activity: "",
      module_mfl: "",
      hrs: "",
    },
  ]);


  const handleDate = (date, name) => {
    //  let newvalue = convert(date);
    if (date == null) {
      setState((prevData) => ({ ...prevData, [name]: null }));
      return;
    }
    let newDate = date.format(DATE_FORMAT.ISO);
    setState((prevData) => ({ ...prevData, [name]: newDate }));
  };

  const handleCustomSelectChange = (e, key) => {
    const value = key === "hrs" ? e.target.value : e.value; // Extract the value based on the key

    setSessionTempData((prevData) => {
      const updatedData = [...prevData];
      const index = updatedData.length - 1; // Calculate the index based on the length of existingData
      updatedData[index][key] = value;
      console.log("Updated Data from handle Custom Select -> ", updatedData);
      return updatedData;
    });
  };

  const handleViewclick = async () => {
    console.log("Searching...");
    setState((prevState) => ({ ...prevState, tableFlag: true }));
  };
  const handleViewclick1 = async () => {
    console.log("Searching...");
    setState((prevState) => ({ ...prevState, tableFlag1: true }));
  };

  const handleHrsMouseLeave = () => {
    console.log("Data in session Temp in Handler -> ", sessionTempData);
    const newSessionRow = {};
    Object.keys(sessionTempData[0]).forEach((key) => {
      newSessionRow[key] = sessionTempData[0][key];
    });

    setSessionData((prevData) => {
      const newData = [...prevData];
      newData.push(newSessionRow);
      return newData;
    });

    setSessionTempData([
      {
        project_type: "",
        barrel: "",
        project_details: "",
        evm_activity: "",
        module_mfl: "",
        hrs: "",
      },
    ]);
  };

  const data = [
    {
      project_type: (
        <CustomSelect
          isMandatory
          // markIfUnselected={highlightMandatoryFields}
          // resetAllVisitedFields={resetAllVisitedFields}
          className={clsx(styles.select, styles.sel2)}
          isClearable
          options={projectOption}
          onChange={(selectedOption) =>
            handleCustomSelectChange(selectedOption, "project_type")
          }
          name="projectOption"
        />
      ),
      barrel: (
        <CustomSelect
          isMandatory
          // markIfUnselected={highlightMandatoryFields}
          // resetAllVisitedFields={resetAllVisitedFields}
          className={clsx(styles.select, styles.sel2)}
          isClearable
          options={barrel}
          onChange={(selectedOption) =>
            handleCustomSelectChange(selectedOption, "barrel")
          }
          name="barrel"
        />
      ),
      project_details: (
        <CustomSelect
          isMandatory
          // markIfUnselected={highlightMandatoryFields}selectedOption
          // resetAllVisitedFields={resetAllVisitedFields}
          className={clsx(styles.select, styles.sel2)}
          isClearable
          options={projectDetails}
          onChange={(selectedOption) =>
            handleCustomSelectChange(selectedOption, "project_details")
          }
          name="projectDetails"
        />
      ),
      evm_activity: (
        <CustomSelect
          isMandatory
          // markIfUnselected={highlightMandatoryFields}
          // resetAllVisitedFields={resetAllVisitedFields}
          className={clsx(styles.select, styles.sel2)}
          isClearable
          options={evmActivity}
          onChange={(selectedOption) =>
            handleCustomSelectChange(selectedOption, "evm_activity")
          }
          name="evmActivity"
        />
      ),
      module_mfl: (
        <CustomSelect
          isMandatory
          // markIfUnselected={highlightMandatoryFields}
          // resetAllVisitedFields={resetAllVisitedFields}
          className={clsx(styles.select, styles.sel2)}
          isClearable
          options={module}
          onChange={(selectedOption) =>
            handleCustomSelectChange(selectedOption, "module_mfl")
          }
          name="module"
        />
      ),
      hrs: (
        <ValidatingTextField
          variant="outlined"
          size="small"
          onChange={(e) => handleCustomSelectChange(e, "hrs")}
          name="hour"
          onBlur={handleHrsMouseLeave}
          inputProps={{
            "data-testid": "remark-input",
          }}
          style={{ width: "100%" }}
        />
      ),
    },
  ];

  const addRow = () => {
    const newRow = {};
    Object.keys(data[0]).forEach((key) => {
      newRow[key] = data[0][key];
    });

    setExistingData([...existingData, newRow]);
  };

  const sendDataToTable = () => {
    setState((prevState) => ({ ...prevState, checkTable: true }));

  };

  //
  const [isPopupOpenFormModal, setPopupOpenFormModal] = useState(false);
  const handleOpenFormModal = () => {
    setPopupOpenFormModal(true);
  };
  const handleCloseFormModal = () => setPopupOpenFormModal(false);

  //

  //
  const [reseVC, setReseVC] = useState(false);
  const handleOpenVCResetModal = () => {
    setReseVC(true);
  };
  const handleCloseVCResetModal = () => setReseVC(false);


  const handleClose = () => setIsPopupOpen(false);
  // start
  const [selectedRow, setSelectedRow] = useState([]);
  const handleOpen1 = (selected) => {
    setIsPopupOpen1(true);
    setSelectedRow(selected);
  };
  const [isPopupOpen1, setIsPopupOpen1] = useState(false);
  const handleClose1 = () => setIsPopupOpen1(false);
  const tableColumnData = [
    { minBookableHrs: 2, maxBookableHrs: 8, bookedHrs: 5, otHrs: 1 },
    { minBookableHrs: 3, maxBookableHrs: 6, bookedHrs: 4, otHrs: 0 },
    // Additional rows...
  ];
  const goNext1 = () => {
    actionBaseVC();
  };
  const actionBaseVC = () => {
    let ids = selectedRow.map(({ dbId }) => dbId);
    const remainingData = tableArray.filter(({ dbId }) => !ids.includes(dbId));
    setTableArray(remainingData);
    ids = ids.join().split(",");

    const apiFormatedData = {
      id: ids,
    };

    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    console.log("apiFormatedDataJson>>>", apiFormatedDataJson);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}Show_Base_Vc_Data/`, {
      method: "DELETE",
      // headers: headerss,
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: MESSAGE_TYPE.SUCCESS,
          info: "Data is Succesfully Deleted",
          reloads: true, // Set reload to true or false based on your condition

        });
      })
      .catch((error) => {});
  };

  // end

  const goNext = () => {
    uploadFileData();
  };

  const ROW_HEIGHT = 38;
  const redirectToApplicationLandingPage = () => {
    history.push("/");
  };

  const setCount = (count) => {
    setAsnCount(count);
  };

  useEffect(() => {
    getData();
    getdate();
  }, []);
  const getdate = () => {
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}Milestone_calendarView/`, {
      method: "GET",
      headers: headerss,
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        const endDate = responseJson[0].Part_Details_correction_StartDate;
        const startDate = responseJson[0].Part_Details_correction_EndDate;
        setDates((prevData) => ({ ...prevData, endDate, startDate }));
      })
      .catch((error) => {});
  };
  const showTable = () => {
    getTableData("Yes");
    show(true);
  };

  const searchClick = (Date) => {
    Date === "03-07-2023"
      ? setSelectedDate(
          "Mon Jul 03 2023 14:23:00 GMT+0530 (India Standard Time)"
        )
      : // setState(prevState => ({ ...prevState, checkTable: true }))

      Date === "04-07-2023"
      ? setSelectedDate(
          "Tue Jul 04 2023 14:23:00 GMT+0530 (India Standard Time)"
        )
      : Date === "05-07-2023" &&
        setSelectedDate(
          "Wed Jul 05 2023 14:23:00 GMT+0530 (India Standard Time)"
        );
  };

  const handleSelect = (selectedOption, name) => {
    console;
    if (name == "baseVC") {
      show(false);

      setBC(selectedOption);
      // getPlantData(selectedOption)
    } else {
      setPlant(selectedOption);
    }
  };
  const getTableData = (flagParam) => {
    const apiFormatedData = {
      VC: Bc.value,
    };

    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    // Show_Base_Vc_Data_for_PV
    fetch(`${baseUrl}Show_Base_Vc_Data/`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        const tableData = responseJson.data;
        const excelData = tableData.map(
          (
            {
              id,
              VC,
              Part_number,
              Group_Part_number,
              Plant_code,
              BOM_Level,
              Procurement_type,
              Spl_Procurement_type,
              BOM_Quantity_of_Part,
              Unit_of_Measure_BOM,
              Vendor_Code,
              NAME1,
              SOB,
              Usage_Probability,
              final_bom_qty,
              Purchase_Group_details,
              PO_Number,
              PO_Price,
              Part_Description,
              PO_Date,
              PO_Currency,
              Order_Price_unit,
              Cell_Identifier,
              Blocked_item,
              Exception,
              Exception_Classification,
              BOM_Extraction_Date,
              BOM_Explosion_Date,
              Bulk_material_indicator,
              Ref_interplant_assemble,
              Destination_plant,
              Item_category,
              Po_doc_type,
              Exclusion_Flag,
              Exclusion_Reason,
            },
            indexx
          ) => {
            let obj = {
              id: indexx,
              dbId: id,
              VC,
              Part_number,
              Group_Part_number,
              Plant_code,
              BOM_Level,
              Procurement_type,
              Spl_Procurement_type,
              BOM_Quantity_of_Part,
              Unit_of_Measure_BOM,
              Vendor_Code,
              NAME1,
              SOB,
              Usage_Probability,
              final_bom_qty,
              Purchase_Group_details,
              PO_Number,
              PO_Price,
              Part_Description,
              PO_Date,
              PO_Currency,
              Order_Price_unit,
              Cell_Identifier,
              Blocked_item,
              Bulk_material_indicator,
              Ref_interplant_assemble,
              Destination_plant,
              Item_category,
              Po_doc_type,
              Exception,
              Exception_Classification,
              Exclusion_Flag,
              Exclusion_Reason,
              BOM_Extraction_Date,
              BOM_Explosion_Date,
            };

            return obj;
          }
        );
        setTableArray(excelData);
        if (flagParam == "Yes") {
          exportExcel(excelData);
        }
        setLoader(false);
      })
      .catch((error) => {});
  };
  const goNextForm = () => {
    var url;
    var urlMethod;

    let { userRole, userID } = auth;

    if (userRole.includes("GDC")) {
      url = "ColourVcMISProgress";
      urlMethod = "POST";
    } else if (
      userRole.includes("Purchase") ||
      userRole.includes("Purchase-CV")
    ) {
      url = "ColourVcMISProgress";
      urlMethod = "PUT";
    } else {
      url = "ColourVcMISProgress";
      urlMethod = "POST";
    }
    const apiFormatedData = {
      VC: Bc.value,
    };

    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}${url}/`, {
      method: urlMethod,
      headers: headerss,
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: MESSAGE_TYPE.SUCCESS,
          info: "Data is Succesfully Saved",
          reloads: true, // Set reload to true or false based on your condition
        });
        history.push("/");
      })
      .catch((error) => {});
  };
  const resetVCCall = () => {
    const apiFormatedData = {
      VC: Bc.value,
    };

    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}Show_Base_Vc_Data/`, {
      method: "PATCH",
      headers: headerss,
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: MESSAGE_TYPE.SUCCESS,
          info: "Data is succesfully reset",
        });
      })
      .catch((error) => {});
  };

  const baseDefaultColumns = [
    {
      width: 150,
      title: "ID",
      field: "id",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 180,
      title: "Date",
      field: "date",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 250,
      title: "Project Details",
      field: "projectdetails",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 250,
      title: "EVM Activity",
      field: "evm",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 250,
      title: "Module (MFL)",
      field: "module",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 180,
      title: "Status",
      field: "status",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 180,
      title: "Hrs",
      field: "hrs",
      enableSearch: true,
      enableFilter: true,
    },
    // {
    //     width: 180,
    //     title: 'Edit',
    //     field: 'edit',
    //     enableSearch: true,
    //     enableFilter: true,
    //     render: (row) => (
    //         <div>
    //             <IconButton
    //             color="primary"
    //             className={styles.deleteIcon}
    //             >
    //             <EditIcon />
    //            </IconButton>
    //         </div>

    //             )
    // },
    // {
    //     width: 180,
    //     title: 'Delete',
    //     field: 'delete',
    //     enableSearch: true,
    //     enableFilter: true,
    //     render: (row) => (
    //         <div>
    //             <IconButton
    //                           color="primary"
    //                           className={styles.deleteIcon}
    //                         >
    //                           <DeleteIcon />
    //                         </IconButton>
    //         </div>

    //             )

    // },
  ];

  const getData = () => {
    const apiFormatedData = {
      BascVC: "",
      Mfg_plant: "",
    };

    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}Show_Base_Vc_Data/`, {
      method: "GET",
      headers: headerss,
      //    body: apiFormatedDataJson
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        const ListArray = responseJson.map(({ VC }) => ({
          value: VC,
          label: VC,
        }));
        setBcArray(ListArray);
      })
      .catch((error) => {});
  };

  const uploadFileData = () => {
    var input = document.createElement("input");
    input.type = "file";
    input.setAttribute(
      "accept",
      ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    );
    input.click();
    input.onchange = (e) => {
      setLoader(true);
      show(true);

      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      fetch(`${baseUrl}Show_Base_Vc_Data/`, {
        method: "PUT",
        body: formData,
      })
        .then((response) => {
          // eslint-disable-next-line radix
          let status1 = parseInt(response.status);
          if (status1 == "201") {
            //   document.removeChild(input);

            getTableData("No");
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: "file uploaded sucessfully",
            });
          } else {
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: "file uploaded failed",
            });
          }
        })

        .catch((error) => {});
    };
  };

  const exportExcel = async (excelData) => {
    var fileTypel =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    var fileExt = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { booktype: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileTypel });
    FileSaver.saveAs(data, `ColorVCDataCV${fileExt}`);
  };
  const filterExcel = async (excelData) => {
    var fileTypel =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    var fileExt = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { booktype: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileTypel });
    FileSaver.saveAs(data, `FilteredColorVCDataCV${fileExt}`);
  };

  const redirectToCreateProjectPage = () => history.push("/");
  const redirectToProjectEditPage = (id) => history.push(`/`);
  const redirectToProjectDetailsPage = (id) => history.push(`/`);

  const renderHTML = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{
          marginTop: "10px",
        }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={6} lg={6}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Operative Personnel Number</label>
            </div>
            <div className={styles.formDiv}>
              <ValidatingTextField
                variant="outlined"
                size="small"
                value={personnelNumber}
                onChange={(event) => {
                  const newValue = event.target.value;
                  setPersonnelNumber(newValue);
                }}
                name="projectSearch"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                data-testid="confirm-action"
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  setSubmitPressed(true);
                }}
              >
                Submit
              </Button>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                data-testid="confirm-action"
                style={{ marginLeft: "10px" }}
                onClick={() => handleViewclick1()}
              >
                Operatives List
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const renderBody = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Booking Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                // onError={dateValidation}
                clearable
                inputVariant="outlined"
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                onChange={(date) => setSelectedDate(date)}
                value={selectedDate}
                emptyLabel="dd/mm/yyyy"
                format="DD/MM/yyyy"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </Grid>

        <Grid item md={3} lg={3}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                style={{ marginLeft: "10px" }}
                variant="primary"
                onClick={() => setSubmitClicked(true)}
                // data-testid="save-confirm"
              >
                SUBMIT
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const renderReport = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        {/* {viewDatesToBook && ( */}
        <Grid item md={12} lg={12} xs={12}>
          <TableSimple
            tableColumnData={[
              {
                date: (
                  <Button
                    data-testid="confirm-action"
                    style={{ marginLeft: "10px" }}
                    onClick={() => searchClick("03-07-2023")}
                  >
                    03-07-2023
                  </Button>
                ),
                bookedHrs: "WED",
              },
              {
                date: (
                  <Button
                    data-testid="confirm-action"
                    style={{ marginLeft: "10px" }}
                    onClick={() => searchClick("04-07-2023")}
                  >
                    04-07-2023
                  </Button>
                ),
                bookedHrs: "THU",
              },
              {
                date: (
                  <Button
                    data-testid="confirm-action"
                    style={{ marginLeft: "10px" }}
                    onClick={() => searchClick("05-07-2023")}
                  >
                    05-07-2023
                  </Button>
                ),
                bookedHrs: "FRI",
              },
            ]}
            tableHeaderLabel={["Date", "Day"]}
            TableRowHederAling="center"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
            justifyContent="center"
          />
        </Grid>
        {/* )} */}
      </Grid>
    </div>
  );

  const renderOperativesDetails = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={12} lg={12} xs={12}>
          <TableSimple
            tableColumnData={[
              {
                bcNo: (
                  <Button
                    data-testid="confirm-action"
                    style={{ marginLeft: "10px" }}
                    onClick={() => {
                      setPersonnelNumber("193554");
                      setShowOperativeList(false);
                    }}
                  >
                    193554
                  </Button>
                ),
                employeeName: "Samrendra Nath Mishra",
              },
            ]}
            tableHeaderLabel={["Employee No", "Employee Name"]}
            TableRowHederAling="center"
            size="50%"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        style={{
          marginTop: "10px",
          marginBottom: "10px",
          justifyContent: "center",
        }}
        columns={12}
      >
        <Grid item md={1} lg={1} xs={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="primary"
                style={{ marginLeft: "10px" }}
              >
                CANCEL
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
  const renderAttendanceDetails = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={12} lg={12} xs={12}>
          <TableSimple
            tableColumnData={[
              {
                minBookableHrs: "8.75",
                maxBookableHrs: "8.75",
                bookedHrs: "0",
                otHrs: "0",
              },
            ]}
            tableHeaderLabel={[
              "Min Bookable Hrs.",
              "Max Bookable Hrs.",
              "Booked Hrs",
              "OT Hrs.",
            ]}
            TableRowHederAling="center"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={12} lg={12} xs={12}>
          <div
            style={{ maxHeight: "400px", overflow: "auto", marginTop: "10px" }}
          >
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
              <thead>
                <tr>
                  <th
                    style={{
                      border: "1px solid #e0e0e0",
                      padding: "8px",
                      backgroundColor: "#E6F2FF",
                      color: "#000000",
                    }}
                  >
                    Select
                  </th>
                  <th
                    style={{
                      border: "1px solid #e0e0e0",
                      padding: "8px",
                      backgroundColor: "#E6F2FF",
                      color: "#000000",
                    }}
                  >
                    Project / Indirect Project
                  </th>
                  <th
                    style={{
                      border: "1px solid #e0e0e0",
                      padding: "8px",
                      backgroundColor: "#E6F2FF",
                      color: "#000000",
                    }}
                  >
                    Barrel
                  </th>
                  <th
                    style={{
                      border: "1px solid #e0e0e0",
                      padding: "8px",
                      backgroundColor: "#E6F2FF",
                      color: "#000000",
                    }}
                  >
                    Project Details
                  </th>
                  <th
                    style={{
                      border: "1px solid #e0e0e0",
                      padding: "8px",
                      backgroundColor: "#E6F2FF",
                      color: "#000000",
                    }}
                  >
                    EVM Activity
                  </th>
                  <th
                    style={{
                      border: "1px solid #e0e0e0",
                      padding: "8px",
                      backgroundColor: "#E6F2FF",
                      color: "#000000",
                    }}
                  >
                    Module (MFL)
                  </th>
                  <th
                    style={{
                      border: "1px solid #e0e0e0",
                      padding: "8px",
                      backgroundColor: "#E6F2FF",
                      color: "#000000",
                    }}
                  >
                    Hrs
                  </th>
                  <th
                    style={{
                      border: "1px solid #e0e0e0",
                      padding: "8px",
                      backgroundColor: "#E6F2FF",
                      color: "#000000",
                    }}
                  >
                    Modify
                  </th>
                </tr>
              </thead>
              <tbody>
                {existingData.map((item, index) => (
                  <tr>
                    <td style={{ border: "1px solid #000", padding: "8px" }}>
                      <input
                        type="checkbox"
                        checked={checkedItems[index] || false}
                        onChange={(event) => handleCheckboxChange(event, index)}
                      />
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                      }}
                    >
                      {item.project_type}
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                      }}
                    >
                      {item.barrel}
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                      }}
                    >
                      {item.project_details}
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                      }}
                    >
                      {item.evm_activity}
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                      }}
                    >
                      {item.module_mfl}
                    </td>
                    <td style={{ border: "1px solid #000", padding: "8px" }}>
                      {selectedRow === index ? (
                        <ValidatingTextField
                          variant="outlined"
                          size="small"
                          value={modifiedData[index]?.hrs || ""}
                          onChange={(e) => handleHrsChange(e, "hrs")}
                          name="hour"
                          inputProps={{
                            "data-testid": "remark-input",
                          }}
                          style={{ width: "100%" }}
                        />
                      ) : (
                        item.hrs
                      )}
                    </td>
                    <td style={{ border: "1px solid #000", padding: "5px" }}>
                      <IconButton
                        color="primary"
                        className={styles.deleteIcon}
                        onClick={() => {
                          handleModifyClick(index);
                        }}
                      >
                        <EditIcon />
                      </IconButton>

                      <IconButton style={{ color: "#f17c7c" }}>
                        <DeleteIcon />
                      </IconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={0}
        style={{ marginTop: "10px", justifyContent: "left" }}
        // className={styles.myGrid}
        columns={12}
      >
        <Grid item md={1} lg={1}>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={addRow}
            data-testid="confirm-action"
          >
            +
          </Button>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px", justifyContent: "center" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={1} lg={1} xs={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                data-testid="confirm-action"
                style={{ marginRight: "5px" }}
                onClick={sendDataToTable}
              >
                Submit
              </Button>

              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                onClick={() => {
                  extractProjectDetailsAndHrs(modifiedData, setExtractedData);
                }}
                style={{ marginRight: "5px" }}
              >
                Edit
              </Button>
              
            </div>
          </div>
        </Grid>
      </Grid>

      {myState.checkTable && (
        <>
          <Grid
            container
            spacing={1}
            style={{
              marginTop: "10px",
            }}
            className={styles.myGrid}
            columns={12}
          >
            <Grid item md={12} lg={12} xs={12}>
              <TableSimple
                tableColumnData={[
                  {
                    projectCode: "W.22.EV.711",
                    projectDescription: "Test Project - Time Booking",
                    gate: "FSR-Final Status Report",
                    aggregate: "Vehicle",
                    activity: "Advance Engg",
                    hour: 8.75,
                    delete: (
                      <div>
                        <IconButton
                          color="primary"
                          className={styles.deleteIcon}
                        >
                          <EditIcon />
                        </IconButton>

                        <IconButton
                          color="primary"
                          className={styles.deleteIcon}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </div>
                    ),
                  },
                  
                ]}
                tableHeaderLabel={[
                  "Project Code",
                  "Project Description ",
                  "Gate",
                  "Aggregate",
                  "Activity",
                  "Hour",
                  "Action",
                ]}
                TableRowHederAling="start"
                size="small"
                headerColor="#E6F2FF"
                className="custom-table"
              />
            </Grid>
          </Grid>

          <Grid
            container
            spacing={1}
            style={{
              marginTop: "10px",
              justifyContent: "center",
            }}
            className={styles.myGrid}
            columns={12}
          >
            <Grid item md={1} lg={1} xs={4}>
              <div className={styles.rowDiv}>
                <div className={styles.formDiv}>
                  <Button
                    className={clsx(styles.actionButton)}
                    variant="primary"
               
                    style={{ marginRight: "5px" }}
                  >
                    Save
                  </Button>

                  <Button
                    className={clsx(styles.actionButton, styles.resetButton)}
                    variant="primary"
                    
                    style={{ marginRight: "5px" }}
                  >
                    CANCEL
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </>
      )}
     
    </div>
  );

  return (
    <>
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
            <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>

          <BackButton
            action="Home"
            handleClick={redirectToApplicationLandingPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Operative Booking" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>
            <UserInfoPanel
              userInfo={[
                {
                  Name: "Aditya Mathur",
                  "SAP ID": 122355,
                  "BC No": "122355",
                  LOC: "Engineering and Research Center",
                },
              ]}
            />
          </div>
        </div>

        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
        >
          <CustomFormGroup
            header="Operative Wise Booking"
            body={renderHTML()}
          />

          {myState.tableFlag1 && (
            <CustomFormGroup
              header="Operative List"
              body={renderOperativesDetails()}
            />
          )}
          {personnelNumber && submitPressed && (
            <>
              <CustomNameTab
                header1="Aditya Mathur"
                header2="0002200010"
                body={renderBody()}
              />

              <CustomFormGroup header="Bookable Dates" body={renderReport()} />
            </>
          )}

          {submitClicked && selectedDate && (
            <CustomFormGroup
              header="Attendance Details"
              body={renderAttendanceDetails()}
            />
          )}

   
        </div>

        {flag && (
          <div
            className={styles.tableView}
            style={{ height: "86%", padding: "0 2em" }}
          >
         
          </div>
        )}
      </div>
      <ResetModalVC
        isPopupOpen={reseVC}
        handleCloseVCModal={handleCloseVCResetModal}
        resetVCCall={resetVCCall}
      />

      <ResetModalF
        isPopupOpen={isPopupOpenFormModal}
        handleCloseFormModal={handleCloseFormModal}
        goNextForm={goNextForm}
      />
      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        goNext={goNext}
      />

      <ResetModal2
        isPopupOpen1={isPopupOpen1}
        handleClose1={handleClose1}
        goNext1={goNext1}
      />
    </>
  );
};
function ResetModalVC({ isPopupOpen, handleCloseVCModal, resetVCCall }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Confirm Reset
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            {/* <p> On confirmation, All existing data will be overwritten by the uploaded data.</p> */}
            <p>
              On confirmation, Selected VC BoM will get reset and all changes
              made will be lost
            </p>

            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCloseVCModal}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleCloseVCModal();
              resetVCCall();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}
function ResetModalF({ isPopupOpen, handleCloseFormModal, goNextForm }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Confirm Submit
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            {/* <p> On confirmation, All existing data will be overwritten by the uploaded data.</p> */}
            <p>On confirmation ,VC BoM data will submit</p>

            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCloseFormModal}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleCloseFormModal();
              goNextForm();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal({ isPopupOpen, handleClose, goNext }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Confirm file Upload
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            {/* <p> On confirmation, All existing data will be overwritten by the uploaded data.</p> */}
            <p>On confirmation ,Records will be appended.</p>

            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose();
              goNext();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal2({ isPopupOpen1, handleClose1, goNext1 }) {
  return (
    <Dialog
      open={isPopupOpen1}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Selected data will be deleted
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            <p> On confirmation, Selected data will be deleted.</p>
            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose1}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              goNext1();
              handleClose1();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  goNext: PropTypes.func.isRequired,
};
ResetModalF.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleCloseFormModal: PropTypes.func.isRequired,
  goNextForm: PropTypes.func.isRequired,
};
ResetModalVC.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleCloseVCModal: PropTypes.func.isRequired,
  resetVCCall: PropTypes.func.isRequired,
};

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  goNext: PropTypes.func.isRequired,
};
ResetModal2.propTypes = {
  isPopupOpen1: PropTypes.bool.isRequired,
  handleClose1: PropTypes.func.isRequired,
  goNext1: PropTypes.func.isRequired,
};

export default withAllowedOperationsProvider(
  OperativeDailyBooking,
  RESOURCE_TYPE.PROJECT
);
